// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"87ff4fe5","300":"aa6cec2d","388":"fcc1fea9","917":"0ff34bf7","939":"1dd15130"}[chunkId] + ".chunk.js";
};